import { TooltipedIconComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';

export interface OperatorCustomNotificationEditCommandComponentProps {
    notificationId: string;
    notificationName: string;
    onEdit: (notificationId: string) => void;
}

export const OperatorCustomNotificationEditCommandComponent: React.FC<
    OperatorCustomNotificationEditCommandComponentProps
> = ({ notificationId, notificationName, onEdit }) => {
    const { t } = useTranslation();

    return (
        <TooltipedIconComponent
            icon="write"
            tooltipText={t(`${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.bulk-actions.actions.edit`)}
            ariaLabel={t(`${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.bulk-actions.actions.edit-aria`, {
                name: notificationName,
            })}
            family="outlined"
            dataTestId={`operator-custom-notification-edit-command-${notificationId}`}
            onClick={(ev) => {
                ev.stopPropagation();
                onEdit(notificationId);
            }}
        />
    );
};
